import { useSelector } from 'react-redux'
import { useState } from 'react'
import { URLS } from '../../const/nav'
import { authFetch } from '../../services/authFetch'

export const useSearchInstitution = () => {
  const { user } = useSelector(state => state)
  const [institution, setInstitution] = useState(null)

  const getInstitution = async (id) => {
    if (!id) {
      console.warn('getInstitution: id is undefined or null')
      return
    }

    const response = await authFetch(`${URLS.BACKEND_URL}/instituciones/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${user.token}`
      }
    })
    const data = await response.json()
    setInstitution(data)
  }

  return { institution, getInstitution }
}
